import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import "../styles/auth.css";

/* Public sign-in page (port of login.html). Posts to /api/login (sets cookie),
 * then refreshes the auth context and lands on Home. */
export default function Login() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [regOpen, setRegOpen] = useState(false);

  useEffect(() => {
    fetch("/api/registration")
      .then((r) => r.json())
      .then((j) => setRegOpen(!!j.open))
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const f = e.target;
    try {
      const r = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: f.username.value,
          password: f.password.value,
        }),
      });
      if (r.ok) {
        await refresh();
        navigate("/", { replace: true });
        return;
      }
      const j = await r.json().catch(() => ({}));
      setErr(j.error || "Sign in failed");
    } catch {
      setErr("Network error — try again");
    }
    setBusy(false);
  };

  return (
    <div className="auth-body">
      <div className="auth-wrap">
        <aside className="auth-info">
          <div className="ibrand">
            <span className="logo">▦</span>
            <div>
              <div className="title">Liquidation Heatmap</div>
              <div className="subtitle">forward-projected liquidity · near-realtime</div>
            </div>
          </div>
          <h2>See where leverage gets liquidated — and act on it.</h2>
          <p className="lead">
            A real-time liquidation-density map plus a full toolchain: charting,
            alerts to Telegram, and automated trading bots on one shared
            methodology.
          </p>
          <div className="feat-li">
            <span className="ic">▦</span>
            <div>
              <b>Liquidation heatmap &amp; charting</b>
              <span>Forward-projected liquidity bands over live candles, with full drawing tools.</span>
            </div>
          </div>
          <div className="feat-li">
            <span className="ic">🔔</span>
            <div>
              <b>Alerts</b>
              <span>Detectors over the heatmap fire to your Telegram channels — no browser needed.</span>
            </div>
          </div>
          <div className="feat-li">
            <span className="ic">🤖</span>
            <div>
              <b>Trading bots</b>
              <span>Paper, testnet or live — sizing, stops, trailing, validators and more.</span>
            </div>
          </div>
          <div className="feat-li">
            <span className="ic">🔒</span>
            <div>
              <b>Permission-based access</b>
              <span>You see only what your role grants. Ask an admin to unlock more.</span>
            </div>
          </div>
        </aside>

        <form className="auth-card" onSubmit={submit} autoComplete="on">
          <div className="brand">
            <span className="logo">▦</span>
            <div>
              <div className="title">Liquidation Heatmap</div>
              <div className="subtitle">sign in to continue</div>
            </div>
          </div>

          <label htmlFor="username">Username</label>
          <input id="username" name="username" autoComplete="username" autoFocus required />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
          />

          <button type="submit" disabled={busy}>
            Sign in
          </button>
          <div className="err">{err}</div>
          {regOpen && (
            <div className="alt">
              No account? <Link to="/register">Create one</Link>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
